import { useLoadingContext } from "hooks"

export default function ContextLoader() {
    const { loadingCount } = useLoadingContext()

    if (loadingCount)
        return (<div className="loading" />)
    return null;
}